var React = require('react');

function DArrowCTA (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M0,3.718,3.718,0,7.437,3.718","transform":"translate(7.791 4.072) rotate(180)","fill":"none","stroke":"#00b4dc","strokeWidth":"1"}));
}

DArrowCTA.defaultProps = {"width":"8.144","height":"4.779","viewBox":"0 0 8.144 4.779"};

module.exports = DArrowCTA;

DArrowCTA.default = DArrowCTA;
